import { editMultiTcinInfoService } from '../../services/editMultiService'
import { showNotification } from '../Notification/actionCreator'
import {
  SET_EDIT_MULTI_LOADING,
  SET_EDIT_MULTI_DATA,
  SET_EDIT_MULTI_DATA_ERROR,
} from './actionTypes'

export const setEditMultiLoading = (data) => {
  return {
    type: SET_EDIT_MULTI_LOADING,
    payload: data,
  }
}

export const setEditMultiData = (data) => {
  return {
    type: SET_EDIT_MULTI_DATA,
    payload: data,
  }
}

export const editMultiTcinAction = ({ body = {} }) => {
  return async (dispatch, getState) => {
    dispatch(setEditMultiLoading(true))
    editMultiTcinInfoService({ body })
      .then((res = {}) => {
        const { data = {} } = res
        dispatch(setEditMultiData(data))
      })
      .catch((error) => {
        dispatch({ type: SET_EDIT_MULTI_DATA_ERROR })
        dispatch(
          showNotification(
            true,
            'Error while getting tcin details',
            'error',
            1000
          )
        )
      })
  }
}
